export default __webpack_public_path__ + "static/seatsplanet-book-rides-701a10cdd93f87922b9edd07200de865.gif";